export const dataTableFieldsEn = {
  dataTableFields: {
    name: 'Name',
    form: 'Form',
    building: 'Building',
    date: 'Date',
    comments: 'Comments',
    unspecified: 'Unspecified',
    lastModified: 'Last Modified',
    workOrder: 'Work Order',
    clientName: 'Client Name',
    email: 'Email',
    phone: 'Phone',
    unit: 'Unit',
    property: 'Property',
    city: 'City',
    details: 'Details',
    timestamp: 'Timestamp',
    category: 'Category',
    status: 'Status',
    disclaimer: 'Disclaimer',
    // Call Tracking column headers
    answeredBy: 'Answered By',
    availableUnits: 'Available Units',
    callerInfo: 'Caller Info',
    callerNumber: 'Caller #',
    dateAndTime: 'Date & Time',
    duration: 'Duration',
    forwardedNumber: 'Forwarded #',
    forwardingNumber: 'Forwarding #',
    inquiries: 'Inquiries',
    inquiriesMessages: 'Inquiries - Messages',
    inquiriesPhone: 'Inquiries - Phone',
    ivr: 'IVR',
    label: 'Label',
    message: 'Message',
    minutes: 'Minutes',
    province: 'Province',
    recording: 'Recording',
    source: 'Source',
    trackingNumber: 'Tracking #',
    type: 'Type',
    // User Management column headers
    userGroups: 'User Groups',
    lastLogin: 'Last Login',
    actions: 'Actions',
    impersonate: 'Impersonate',
    groupName: 'Group Name',
    users: 'Users',
    account: 'Account',
    website: 'Website',
    inviteSent: 'Invite Sent',
    unitExclusionsDisabled: 'Disabled because unit exclusions are turned off for all properties in Listing Settings.',
  },
} as const;
export const dataTableFieldsFr = {
  dataTableFields: {
    name: 'Nom',
    form: 'Formulaire',
    building: 'Propriété',
    date: 'Date',
    comments: 'Commentaires',
    unspecified: 'Non spécifié',
    lastModified: 'Dernière modification',
    workOrder: 'No de demande',
    clientName: 'Nom du client',
    email: 'Courriel',
    phone: 'Téléphone',
    unit: 'Unité',
    property: 'Propriété',
    city: 'Ville',
    details: 'Description',
    timestamp: 'Date et heure',
    category: 'Catégorie',
    status: 'Statut',
    disclaimer: 'Avis',
    // Call Tracking column headers
    answeredBy: 'Répondu par',
    availableUnits: 'Unités disponibles',
    callerInfo: 'Info. appelant',
    callerNumber: 'N° de l\'appelant',
    dateAndTime: 'Date et heure',
    duration: 'Durée',
    forwardedNumber: 'N° transféré',
    forwardingNumber: 'N° de transfert',
    inquiries: 'Demandes',
    inquiriesMessages: 'Demandes - Messages',
    inquiriesPhone: 'Demandes - Téléphone',
    ivr: 'RVI',
    label: 'Étiquette',
    message: 'Message',
    minutes: 'Minutes',
    province: 'Province',
    recording: 'Enregistrement',
    source: 'Source',
    trackingNumber: 'N° de suivi',
    type: 'Type',
    // User Management column headers
    userGroups: 'Groupes d\'utilisateurs',
    lastLogin: 'Dernière connexion',
    actions: 'Actions',
    impersonate: 'Usurper l\'identité',
    groupName: 'Nom du groupe',
    users: 'Utilisateurs',
    account: 'Compte',
    website: 'Site Web',
    inviteSent: 'Invitation envoyée',
    unitExclusionsDisabled: 'Désactivé parce que les exclusions de logements sont désactivées pour toutes les propriétés dans les paramètres d\'annonces.',
  },
} as const;
